import React from "react";
import "./App.scss";
import filterLocations from "./shared/util/FilterLocations";
import { initialMapState } from "./containers/Map.state";
import LocationList from "./components/LocationList";
import Map from "./components/Map";
import { MapContext } from "./containers/Map.context";
import { MapReducer } from "./containers/Map.reducer";

const App: React.FC = () => {
  const [state, dispatch] = React.useReducer(MapReducer, initialMapState);
  const { query, regionalOperationCenter } = state;

  const filteredLocations = filterLocations(query, regionalOperationCenter);

  return (
    <div className="App">
      <MapContext.Provider value={{ state, dispatch }}>
        <Map locations={filteredLocations} />

        <LocationList locations={filteredLocations} />
      </MapContext.Provider>
    </div>
  );
};

export default App;
